module.exports = __webpack_public_path__ + "09_long_black.83935b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/09_long_black.png
// module id = BDGa
// module chunks = 0